import React from 'react';

import type { SimpleIconInterface } from './icon-utils';
import { IconColors, SimpleIcon, useSvgId } from './icon-utils';

export function SmallAiSparkleIcon({ className, fill = IconColors.Primary }: SimpleIconInterface) {
  const clipPathId = useSvgId('small-ai-sparkle-clip');

  return (
    <SimpleIcon
      className={className}
      fill="none"
      height="12"
      viewBoxDimensions="0 0 12 12"
      width="12"
    >
      <g clipPath={`url(#${clipPathId})`}>
        <path
          d="M4 12.5C3.73478 12.5 3.48043 12.3946 3.29289 12.2071C3.10536 12.0196 3 11.7652 3 11.5C3 10.9696 2.78929 10.4609 2.41421 10.0858C2.03914 9.71071 1.53043 9.5 1 9.5C0.734784 9.5 0.48043 9.39464 0.292893 9.20711C0.105357 9.01957 0 8.76522 0 8.5C0 8.23478 0.105357 7.98043 0.292893 7.79289C0.48043 7.60536 0.734784 7.5 1 7.5C1.53043 7.5 2.03914 7.28929 2.41421 6.91421C2.78929 6.53914 3 6.03043 3 5.5C3 5.23478 3.10536 4.98043 3.29289 4.79289C3.48043 4.60536 3.73478 4.5 4 4.5C4.26522 4.5 4.51957 4.60536 4.70711 4.79289C4.89464 4.98043 5 5.23478 5 5.5C5 6.03043 5.21071 6.53914 5.58579 6.91421C5.96086 7.28929 6.46957 7.5 7 7.5C7.26522 7.5 7.51957 7.60536 7.70711 7.79289C7.89464 7.98043 8 8.23478 8 8.5C8 8.76522 7.89464 9.01957 7.70711 9.20711C7.51957 9.39464 7.26522 9.5 7 9.5C6.46957 9.5 5.96086 9.71071 5.58579 10.0858C5.21071 10.4609 5 10.9696 5 11.5C5 11.7652 4.89464 12.0196 4.70711 12.2071C4.51957 12.3946 4.26522 12.5 4 12.5Z"
          fill={fill}
        />
        <path
          d="M9.5 5.5C9.33424 5.5 9.17527 5.43415 9.05806 5.31694C8.94085 5.19973 8.875 5.04076 8.875 4.875C8.87447 4.54364 8.7426 4.22601 8.5083 3.9917C8.27399 3.75739 7.95636 3.62553 7.625 3.625C7.45924 3.625 7.30027 3.55915 7.18306 3.44194C7.06585 3.32473 7 3.16576 7 3C7 2.83424 7.06585 2.67527 7.18306 2.55806C7.30027 2.44085 7.45924 2.375 7.625 2.375C7.95636 2.37447 8.27399 2.24261 8.5083 2.0083C8.7426 1.77399 8.87447 1.45636 8.875 1.125C8.875 0.95924 8.94085 0.800268 9.05806 0.683058C9.17527 0.565848 9.33424 0.5 9.5 0.5C9.66576 0.5 9.82473 0.565848 9.94194 0.683058C10.0592 0.800268 10.125 0.95924 10.125 1.125C10.1255 1.45636 10.2574 1.77399 10.4917 2.0083C10.726 2.24261 11.0436 2.37447 11.375 2.375C11.5408 2.375 11.6997 2.44085 11.8169 2.55806C11.9342 2.67527 12 2.83424 12 3C12 3.16576 11.9342 3.32473 11.8169 3.44194C11.6997 3.55915 11.5408 3.625 11.375 3.625C11.0436 3.62553 10.726 3.75739 10.4917 3.9917C10.2574 4.22601 10.1255 4.54364 10.125 4.875C10.125 5.04076 10.0592 5.19973 9.94194 5.31694C9.82473 5.43415 9.66576 5.5 9.5 5.5Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id={clipPathId}>
          <rect fill="white" height="12" transform="translate(0 0.5)" width="12" />
        </clipPath>
      </defs>
    </SimpleIcon>
  );
}
